












































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    //SkriningMppModal
  }
})
export default class ListSkriningMpp extends Vue {
  @Prop({ default: () => [] }) readonly items!: any[];
  @Prop({ default: "500px" }) readonly height!: string;
  @Prop({ type: Boolean, default: false }) isReadonly!: boolean;

  get headers() {
    const allHeaders = [
      {
        text: "No",
        value: "no",
        sortable: false,
        align: "center",
        width: "3%"
      },
      {
        text: "Tanggal / Ruang / Petugas",
        value: "info",
        sortable: false,
        width: "20%"
      },
      { text: "Daftar Risiko", value: "risiko", sortable: false, width: "47%" },
      { text: "Problem", value: "problem", sortable: false, width: "25%" },
      {
        text: "Aksi",
        value: "aksi",
        sortable: false,
        align: "center",
        width: "5%"
      }
    ];
    if (this.isReadonly) {
      return allHeaders.filter(h => h.value !== "aksi");
    }
    return allHeaders;
  }

  formatTanggal(date: string) {
    if (!date) return "-";
    return moment(date).format("DD-MM-YYYY HH:mm");
  }

  get sortedItems() {
    return [...this.items].sort((a, b) => {
      const dateA = new Date(a.authored_at).getTime();
      const dateB = new Date(b.authored_at).getTime();
      return dateB - dateA;
    });
  }

  getRowData(item: any) {
    if (!item || !item.content) return [];

    return Object.keys(item.content).map(key => {
      const dataAspek = item.content[key];
      return {
        kategori: dataAspek.judul,
        daftarRisiko: dataAspek.risiko || []
      };
    });
  }

  get stateUser() {
    return userModule.user;
  }

  isRowReadonly(item: any): boolean {
    if (this.isReadonly) return true;

    if (!this.stateUser) return true;

    const isOwner = Number(item.user_id) === Number(this.stateUser.id);
    const isSameUnit = String(item.unit_id) === String(this.stateUser.unit_id);

    return !(isOwner && isSameUnit);
  }
}
